<app-game-component [hidden]="loading" [layouts]="layouts"></app-game-component>
